import React from "react";
import Header from "../../components/Header";
import Typer from "../../components/Typer";
import {
  Row,
  Col,
  Typography,
  Descriptions,
  Image,
  //   Divider,
  Space,
  Button,
} from "antd";
import ImageMe from "../../assets/me1.png";
import Gear from "../../assets/gear.png";

function calculateAge(birthDate) {
  // Ubah tanggal lahir menjadi objek Date
  birthDate = new Date(birthDate);
  // Dapatkan tahun, bulan, dan tanggal sekarang
  var now = new Date();
  var yearNow = now.getFullYear();
  var monthNow = now.getMonth();
  var dateNow = now.getDate();
  // Dapatkan tahun, bulan, dan tanggal dari tanggal lahir
  var yearBirth = birthDate.getFullYear();
  var monthBirth = birthDate.getMonth();
  var dateBirth = birthDate.getDate();
  // Hitung perbedaan tahun
  var yearDiff = yearNow - yearBirth;
  // Jika bulan sekarang lebih kecil dari bulan lahir, kurangi perbedaan tahun dengan satu
  if (monthNow < monthBirth) {
    yearDiff--;
    // Jika bulan sekarang sama dengan bulan lahir, tetapi tanggal sekarang lebih kecil dari tanggal lahir, kurangi perbedaan tahun dengan satu
  } else if (monthNow == monthBirth && dateNow < dateBirth) {
    yearDiff--;
  }
  // Kembalikan perbedaan tahun sebagai umur
  return yearDiff;
}

const About = ({ isBreakPosition }) => {
  return (
    <div style={{ margin: "24px" }}>
      <Header
        width={isBreakPosition ? 12 : 6}
        title="About Me"
        desciption="Main Information About Me"
      />
      {!isBreakPosition && (
        <img
          alt="gear-background"
          style={{ right: 0, position: "absolute" }}
          src={Gear}
        />
      )}
      <Row>
        <Col style={{ marginTop: "10vmin" }} span={isBreakPosition ? 24 : 12}>
          <Typer
            level={3}
            heading="I'am Brilli and"
            messages={[
              "Fullstack Developer",
              "Mobile Apps Developer",
              "Illustrator",
              "Frontend Developer",
            ]}
            messagesColor="#E3872D"
          />
          <Typography.Paragraph style={{ fontSize: "16px" }}>
            Hi! My name is{" "}
            <span style={{ color: "#E3872D" }}>Brilliano Dhiya Ulhaq</span>. I
            am a Frontend Developer who has respects the arts in making UI in
            the programming world. My experience in the field of making
            applications is approximately {calculateAge("2017-01-01")} years
            since I was in high school. With experience developing several
            technologies including, RESTful API, web-based applications using
            API or PHP Native, android-based applications. I also continue to
            open services for creating web and android based applications in
            some rest time i make youtube content too.
          </Typography.Paragraph>
          <Descriptions
            title="More Information About me ?"
            column={isBreakPosition ? 1 : 2}
          >
            <Descriptions.Item label={<b>Birthday</b>}>
              August 24th, 2000
            </Descriptions.Item>
            <Descriptions.Item label={<b>Age</b>}>
              {calculateAge("2000-08-24")}
            </Descriptions.Item>
            <Descriptions.Item label={<b>City</b>}>
              Trenggalek, West Java Indonesia
            </Descriptions.Item>
            <Descriptions.Item label={<b>Interests</b>}>
              Web Design, Development, Game
            </Descriptions.Item>
            <Descriptions.Item label={<b>Company</b>}>
              IKI, AITI Lokal
            </Descriptions.Item>
            <Descriptions.Item label={<b>Mail</b>}>
              brillidhiya@gmail.com
            </Descriptions.Item>
            <Descriptions.Item label={<b>Instagram</b>}>
              @brilliano_d
            </Descriptions.Item>
            <Descriptions.Item label={<b>Phone</b>}>
              +6285155436866
            </Descriptions.Item>
          </Descriptions>

          {!isBreakPosition && (
            <Space size="large" style={{ marginTop: "5vmin" }}>
              <Button
                size="large"
                block
                type="primary"
                onClick={() =>
                  window.open(
                    "https://drive.google.com/file/d/1OsWOVOBk6WZ12l1ZdvJm4Z8ulN4p-QAJ/view?usp=sharing"
                  )
                }
              >
                Download Resume
              </Button>
              <Button
                size="large"
                block
                type="primary"
                onClick={() =>
                  window.open("mailto:brillidhiya@gmail.com?subject=Hello")
                }
              >
                Send me a Message
              </Button>
            </Space>
          )}
        </Col>
        <Col
          span={isBreakPosition ? 24 : 10}
          style={{
            maxHeight: 515,
            overflow: "hidden",
            borderBottom: "3px solid",
          }}
        >
          {isBreakPosition && (
            <img
              alt="gear-background"
              style={{ right: 0, position: "absolute" }}
              src={Gear}
            />
          )}
          <Image
            width={362}
            src={ImageMe}
            style={{
              marginTop: "30px",
            }}
          />
        </Col>
        {isBreakPosition && (
          <Col span={24} style={{ marginTop: "5vmin" }}>
            <Space size="large">
              <Button
                size="large"
                block
                type="primary"
                onClick={() =>
                  window.open(
                    "https://drive.google.com/file/d/1OsWOVOBk6WZ12l1ZdvJm4Z8ulN4p-QAJ/view?usp=sharing"
                  )
                }
              >
                Download Resume
              </Button>
              <Button
                size="large"
                block
                type="primary"
                onClick={() =>
                  window.open("mailto:brillidhiya@gmail.com?subject=Hello")
                }
              >
                Send me a Message
              </Button>
            </Space>
          </Col>
        )}
      </Row>
    </div>
  );
};

export default About;
